/* unplugin-vue-components disabled */import script from "./CounselorMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./CounselorMenu.vue?vue&type=script&setup=true&lang=js"

import "./CounselorMenu.vue?vue&type=style&index=0&id=705cb70e&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-705cb70e"]])

export default __exports__